import { createSlice, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk'
import { Provider, shallowEqual, useDispatch, useSelector } from 'react-redux';

export const hooks = { useDispatch, useSelector }

export const middlewares = { thunk }

export const methods = { shallowEqual, createSlice, configureStore }

export const components = { Provider }
